import { GenericHeader } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Mastery } from 'services';
import { curriculum_manager } from 'utils/constants';
import { Results } from './components';

const MasteryList = props => {

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Masteries" subheader="Mastery Management" {...rest} >
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Mastery.list}
      title="Masteries"
      name="masteries"
      searchable
      Header={Head}
      Results={Results}
      roles={[curriculum_manager]}
      filters={{ limit: 9999, offset: 0, count: 0 }}
    />
  );
};

export default MasteryList;
